import { isMobile, isTablet } from 'react-device-detect';

export function getDeviceType() {
  if (isMobile) {
    return 'mobile web';
  }

  if (isTablet) {
    return 'tablet';
  }

  return 'desktop';
}



// WEBPACK FOOTER //
// ./src/utils/device.js